module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/search/searchresults/searchresults.component.css
// module id = ./src/app/search/searchresults/searchresults.component.css
// module chunks = main